import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { Utils } from "../../helper/utils.helper";
import { VoterFileService } from "../../services/voter-file.service";
import { VoterFileDataProvider } from "../../data-provider/voter-file.dp";
import { VoterFileImport } from "../../models/voter-file-import.model";
import { SearchUtils } from "../../helper/search.helper";
import { PermissionCheck } from "../../shared/permission";

let ImportSkippedComponent = {
    selector: "vcImportSkipped",
    templateUrl: "/angular/components/voter-file/import-skipped.component.html",
    bindings: {},
    controller: class VoterFilecontroller {
        private readonly __env: any;
        private readonly dialog: DialogUtils;
        public readonly utils: Utils;
        public readonly searchUtils: SearchUtils;

        private $scope: any;
        private $q: any;
        private $interval: any;
        private dataProvider: VoterFileDataProvider;
        public permissionProvider: PermissionCheck;
        private $routeParams: any;
        public selectedItem: any = null;
        public initial_loading = true;
        public import: VoterFileImport;
        public totalSkippedRows = 0;
        public loading: boolean;
        public infiniteItems: ImportSkippedInfiniteItems;
        public service: VoterFileService;
        public searchDelay?: any;
        public searchMode: boolean = false;

        constructor(
            __env: any,
            $scope: any,
            $q: any,
            $routeParams: any,
            $interval: any,
            DialogUtils: DialogUtils,
            Utils: Utils,
            SearchUtils: SearchUtils,
            VoterFileDataProvider: VoterFileDataProvider,
            VoterFileService: VoterFileService,
            PermissionCheck: PermissionCheck
        ) {
            this.__env = __env;
            this.$scope = $scope;
            this.$q = $q;
            this.$interval = $interval;
            this.$routeParams = $routeParams;
            this.searchUtils = SearchUtils;
            this.dialog = DialogUtils;
            this.dataProvider = VoterFileDataProvider;
            this.utils = Utils;
            this.service = VoterFileService;
            this.permissionProvider = PermissionCheck;
        }

        $onInit() {
            this.getTotalConflicts();
        }

        getTotalConflicts(): void {
            this.dataProvider
                .importInfo(this.$routeParams.imid)
                .then((imp: VoterFileImport) => {
                    this.dataProvider
                        .skippedCount(imp.imid)
                        .then((skippedCount) => {
                            this.infiniteItems = new ImportSkippedInfiniteItems(
                                this,
                                this.service,
                                imp.imid
                            );
                            this.totalSkippedRows = skippedCount;
                            this.import = imp;
                            this.setupSearch();
                        });
                });
        }

        setupSearch() {
            this.searchUtils.setSearchBar(
                "Search Users",
                (searchText) => {
                    this.infiniteItems.search = searchText;
                    return this.$q.resolve([]);
                },
                null,
                true
            );
            this.$scope.$watch(
                () => this.infiniteItems.search,
                (newValue: string, oldValue: string) => {
                    if (oldValue != newValue) {
                        this.loading = true;
                        if (this.searchDelay) {
                            this.searchDelay = this.$interval.cancel(
                                this.searchDelay
                            );
                        }
                        this.searchDelay = this.$interval(() => {
                            this.$interval.cancel(this.searchDelay);
                            this.infiniteItems.reset();
                        }, 500);
                    }
                },
                true
            );
        }
    },
};

class ImportSkippedInfiniteItems {
    public finished = false;
    public numLoaded_ = 0;
    public imid: number | string | null;
    public toLoad_ = 0;
    public search = "";
    public loading = false;
    public items: object[] = [];
    public highest_icid: string | number | null = null;
    private readonly controller: any;
    private readonly service: VoterFileService;

    constructor(
        controller: any,
        resource: VoterFileService,
        id: string | number
    ) {
        this.controller = controller;
        this.service = resource;
        this.imid = id;
    }

    reset(): void {
        this.items = [];
        this.numLoaded_ = 0;
        this.toLoad_ = 0;
        this.finished = false;
        this.highest_icid = null;
    }

    getItemAtIndex(index: number | null): object {
        if (index > this.numLoaded_ - 1 && !this.loading) {
            this.fetchMoreItems_(index);
            return null;
        }
        return this.items[index];
    }

    // Required.
    // For infinite scroll behavior, we always return a slightly higher
    // number than the previously loaded items.
    getLength(): number {
        if (this.controller.totalSkippedRows === 0) {
            return 0;
        }
        if (
            this.controller.totalSkippedRows !== 0 &&
            this.numLoaded_ + 5 > this.controller.totalSkippedRows
        ) {
            return this.controller.totalSkippedRows;
        }
        if (this.finished) {
            return this.numLoaded_;
        }
        return this.numLoaded_ + 5;
    }

    fetchMoreItems_(index: number): void {
        if (this.items.length < this.controller.totalSkippedRows) {
            if (this.toLoad_ < index && !this.finished) {
                this.loading = true;
                this.service
                    .skippedRows({
                        id: this.imid,
                        last: this.highest_icid,
                        search: this.search,
                    })
                    .then((response: object) => {
                        const json = response["data"];
                        this.controller.initial_loading = false;
                        if (json.success === true) {
                            this.toLoad_ += 100;
                            this.items = this.items.concat(json.data);
                            this.highest_icid =
                                this.items[this.items.length - 1]["icid"];
                            this.numLoaded_ = this.items.length;
                            if (
                                json.data.length !== 100 ||
                                this.controller.totalSkippedRows <=
                                    this.items.length
                            ) {
                                this.finished = true;
                            }
                            this.loading = false;
                        } else {
                            this.loading = false;
                            this.finished = true;
                        }
                    });
            }
        } else {
            this.loading = false;
            this.finished = true;
        }
    }
}

angular
    .module("voterFile")
    .component(ImportSkippedComponent.selector, ImportSkippedComponent);
